export default function Footer() {
  return (
    <div style={{ padding: "0.5rem 1rem", width: "100%" }}>
      <div style={{ fontSize: "0.85rem", color: "#ccc" }}>
        © {new Date().getFullYear()} Endeavor Elements, Inc.
      </div>
    </div>
  );
}
